import { render, staticRenderFns } from "./WorkflowFormBuilderTemplateDetailCard.vue?vue&type=template&id=02fa513b&scoped=true&"
import script from "./WorkflowFormBuilderTemplateDetailCard.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormBuilderTemplateDetailCard.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowFormBuilderTemplateDetailCard.vue?vue&type=style&index=0&id=02fa513b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fa513b",
  null
  
)

export default component.exports